import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Button } from "@design-system/Inputs/Button";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { type CSVRow, useCsvImport } from "./hooks";

const ImportCSVButton = ({
    onAddIndicators,
    onError,
}: {
    onAddIndicators: (suppliers: CSVRow[]) => void;
    onError: (error: string) => void;
}) => {
    const { t } = useTranslation("CreateIndicatorsModal");
    const ref = useRef<HTMLInputElement>(null);
    const onCsvImport = useCsvImport(onAddIndicators);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            try {
                await onCsvImport(e.target.files[0]);
            } catch (error) {
                onError(
                    error instanceof Error
                        ? error.message
                        : "An unknown error occurred",
                );
            }
        }

        if (ref.current) {
            ref.current.files = null;
            ref.current.value = "";
        }
    };

    return (
        <>
            <input
                ref={ref}
                type="file"
                accept=".csv"
                className="hidden"
                onChange={handleFileChange}
            />
            <Tooltip>
                <Tooltip.Trigger>
                    <Button
                        size="md"
                        variant="tonal"
                        onClick={() => ref.current?.click()}
                    >
                        <Button.Icon name="circleInfo" />

                        {t("import_csv")}
                    </Button>
                </Tooltip.Trigger>
                <Tooltip.Content>{t("import_csv_tooltip")}</Tooltip.Content>
            </Tooltip>
        </>
    );
};

export default ImportCSVButton;
